import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { useAuthStore } from '@/store';

// Mounted once by CoworkerWatcher, including while viewing another chat.
// Do not wait for a completed model response to refresh pending reservations.
export default function useLiveWorkCredits(active, userId, sessionGeneration, authenticated) {
  useEffect(() => {
    if (!authenticated || !userId) return;
    let disposed = false;
    const webDocument = Platform.OS === 'web' && typeof document !== 'undefined' ? document : null;
    const refresh = () => {
      if (disposed || (Platform.OS === 'web' ? webDocument?.visibilityState === 'hidden' : AppState.currentState !== 'active')) return;
      const auth = useAuthStore.getState();
      if (auth.user?.id !== userId || auth._sessionGeneration !== sessionGeneration || !auth.token) return;
      auth.fetchUserCredits?.({ force: true })?.catch?.(() => {});
    };
    refresh(); // Also release the displayed hold when the last task stops.
    if (!active) return () => { disposed = true; };
    const timer = setInterval(refresh, 4000);
    const onVisibility = () => refresh();
    const listener = Platform.OS === 'web'
      ? (webDocument?.addEventListener('visibilitychange', onVisibility), null)
      : AppState.addEventListener('change', onVisibility);
    return () => {
      disposed = true;
      clearInterval(timer);
      if (Platform.OS === 'web') webDocument?.removeEventListener('visibilitychange', onVisibility);
      else listener?.remove();
    };
  }, [active, userId, sessionGeneration, authenticated]);
}
